export const SubscriptionPlanType = {
  FREE: "1",
  CONTRIBUTOR: "2",
  PARTICIPANT: "3",
};
